/*
  Сводка разбора реестра должников: сколько строк, сколько счетов заведётся и
  сколько долга заявила управляющая компания.

  Вынесена из `RegistryUpload` 20.10.2026, когда шаг перешёл на путь «файл один
  раз» и упёрся в норму компонента (250 строк): сводка только раскладывает
  ответ сервера, состояния у неё нет. Разметка и текст перенесены дословно.
*/

import { accounts as accountsCount, money, rows as rowsCount } from '../api/format.js'

export default function RegistryPlan({ plan }) {
  return (
    <div className="onec__summary">
      <p>
        Строк в файле: <b>{rowsCount(plan.total)}</b>. Будет заведено:{' '}
        <b>{accountsCount(plan.to_create)}</b>.{' '}
        {plan.existing > 0 ? <>Уже в портфеле: {plan.existing}.</> : null}{' '}
        {plan.left_out > 0 ? <>Не выбраны вами и не заведутся: {plan.left_out}.</> : null}
      </p>
      <p className="muted">
        В файле заявлено долга: {money(plan.debt_declared)}, из них ко взысканию{' '}
        {money(plan.recoverable_declared)}. Это расчёт управляющей компании - показан для
        сверки. Арбитр ЖКХ посчитает давность и пени сам, по месячным начислениям.
      </p>
    </div>
  )
}
